/* eslint-disable jsx-a11y/no-autofocus */
import { ReducerContext } from '@abdoo/common';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useCallback, useContext, useEffect, useState } from 'react';

export function SetupEntitlementDialog() {
  const { userSettingsState } = useContext(ReducerContext);
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (userSettingsState.initialHolidayDataLoaded && userSettingsState.askToSetupYear) {
      setOpen(true);
    }
  }, [userSettingsState]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="setup-entitlement-title"
    >
      <DialogTitle id="setup-entitlement-title">
        {'Please setup your holiday entitlement'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          You have reached the end of the holiday year, please set up your entitlement for
          the new holiday year
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
